import { ReactElement, useContext } from "react"

import { MFA_MODE_ACCOUNT, MfaPopUp } from "../../appBar/customSetupTOTP"
import { AccountSetUpContext } from "../providers/firstLoginProvider"
import {
    INVITE_ACCEPTED_SUCCESS,
    ORG_SET_UP_SUCCESS,
} from "../screenDispatchers/firstLoginConstants"

/** Allows users to set up MFA as part of their sign-up process */
const MfaSetUp = (): ReactElement => {
    const { setCurrentScreen, isInviteMode } = useContext(AccountSetUpContext)
    const nextScreen = isInviteMode
        ? INVITE_ACCEPTED_SUCCESS
        : ORG_SET_UP_SUCCESS
    return (
        <MfaPopUp
            onSuccess={() => setCurrentScreen(nextScreen)}
            mode={MFA_MODE_ACCOUNT}
        />
    )
}

export default MfaSetUp
